import {client} from '../axios';

import {User} from "@/types/UserType";
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";

export const sendReset = (
    email: string,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/password/reset`, {email})
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
};

export const reset = (
    token: string,
    email: string,
    password: string,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/password/update`, {
        token,
        email,
        password,
        password_confirmation: password
    })
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
};
